import { GET_MARITAL, GET_MARITAL_SUCCESS, GET_MARITAL_FAIL, DELETE_MARITAL, DELETE_MARITAL_SUCCESS, DELETE_MARITAL_FAIL, UPDATE_MARITAL, UPDATE_MARITAL_SUCCESS, UPDATE_MARITAL_FAIL, ADD_NEW_MARITAL, ADD_MARITAL_SUCCESS, ADD_MARITAL_FAIL, MARITAL_LOADING, MARITAL_RESET } from "./actionType";

export const resetMaritalState = (actionType) => ({
  type: MARITAL_RESET,
  payload: { actionType },
});

export const getMaritalSuccess = (actionType, data) => ({
  type: GET_MARITAL_SUCCESS,
  payload: { actionType, data },
});

export const getMaritalFail = (actionType, error) => ({
  type: GET_MARITAL_FAIL,
  payload: { actionType, error },
});

export const getMarital = (data) => ({
  type: GET_MARITAL,
  payload: data,
});

export const getMaritalLoading = () => ({
  type: MARITAL_LOADING,
});

export const deleteMarital = (data) => ({
  type: DELETE_MARITAL,
  payload: data,
});

export const deleteMaritalSuccess = (data) => ({
  type: DELETE_MARITAL_SUCCESS,
  payload: data,
});

export const deleteMaritalFail = (error) => ({
  type: DELETE_MARITAL_FAIL,
  payload: error,
});

export const updateMarital = (data) => ({
  type: UPDATE_MARITAL,
  payload: data,
});

export const updateMaritalFail = (error) => ({
  type: UPDATE_MARITAL_FAIL,
  payload: error,
});

export const updateMaritalSuccess = (data) => ({
  type: UPDATE_MARITAL_SUCCESS,
  payload: data,
});

export const addNewMarital = (data) => ({
  type: ADD_NEW_MARITAL,
  payload: data,
});

export const addMaritalSuccess = (data) => ({
  type: ADD_MARITAL_SUCCESS,
  payload: data,
});

export const addMaritalFail = (error) => ({
  type: ADD_MARITAL_FAIL,
  payload: error,
});
